import { OutcomeScoreTable } from "./OutcomeScoreTable";
import { PagePointTable } from "./PagePointTable";
import { SectionScoreTable } from "./SectionScoreTable";

import { serverGetOutcomeScoreTable, serverGetPagePointTable } from "api/api-server-assessment";
import { EmptyAssessmentDashboard } from "components/materials/section/assessment/EmptyAssessmentDashboard";
import { useAppSelector } from "store/index";
import { selectCurrentSectionId } from "store/selectors";
import { usePromiseEffect } from "store/store-hooks";
import { isOutcomeScoreTableDataSufficient, isSectionScoreDataSufficient } from "utils/assessment";
import { useSectionScoreTable } from "utils/hooks/use-section-score-table";

export const SectionScoreDashboard = () => {
  const sectionId = useAppSelector(selectCurrentSectionId);

  // Use the SectionScore data that was already fetched from the server by SectionScoreTableProvider.
  const { rows: sectionScoreTableRows } = useSectionScoreTable();

  const { data: pagePointTableData } = usePromiseEffect(
    async () =>
      sectionId
        ? serverGetPagePointTable({
            section_id: sectionId,
          })
        : null,
    [sectionId],
  );

  const { data: outcomeScoreTableData } = usePromiseEffect(
    async () =>
      sectionId
        ? serverGetOutcomeScoreTable({
            section_id: sectionId,
          })
        : null,
    [sectionId],
  );

  if (!sectionId) {
    return null;
  }

  const noData =
    (!sectionScoreTableRows || !isSectionScoreDataSufficient(sectionScoreTableRows)) &&
    (!pagePointTableData || pagePointTableData.rows.length === 0) &&
    (!outcomeScoreTableData || !isOutcomeScoreTableDataSufficient(outcomeScoreTableData));

  if (noData) {
    return <EmptyAssessmentDashboard />;
  }

  return (
    <main className="assessment-dashboard">
      <SectionScoreTable sectionScoreTableRows={sectionScoreTableRows} />

      <PagePointTable pagePointTableData={pagePointTableData} />

      <OutcomeScoreTable outcomeScoreTableData={outcomeScoreTableData} />
    </main>
  );
};
